import React from "react";
import abimg1 from "../../images/about/img-2.png";

import "./style.css";

const AboutSection = () => {
  return (
    <div className="about-style-2">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-sm-12 col-m">
            <div className="about-img">
              <img src={abimg1} alt="" />
            </div>
          </div>
          <div className="col-lg-6 col-12">
            <div className="about-content">
              <div className="section-title">
                <h2>About Us</h2>
              </div>
              <h2>Babette Turner</h2>
              <h3>Lawyer</h3>
              <p>
                Babette Turner was called to the Ontario bar in 2014. She
                practices in real estate, wills & estates, and corporate law,
                and is passionate about all things real estate. Babettte has
                been a real estate investor for over 25 years. She has been a
                member of Real Estate Investors Network for over 12 years and a
                member of Ottawa Real Estate Investors Organization for over 15
                years.{" "}
              </p>
              <h2>Ashley Kennedy-Lopez</h2>
              <p>
                Ashley is a valued member of our team providing assistance on
                all real estate transactions and general office management
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutSection;
